// extracted by mini-css-extract-plugin
export var lightMode = "_12-0";